// src/store/slices/chat/chat-slice.ts
import { StateCreator } from "zustand";

export interface ChatSlice {
    chatPrefillMessage: string;
    setChatPrefillMessage: (message: string) => void;
    clearChatPrefillMessage: () => void;
}

export const createChatSlice: StateCreator<
    ChatSlice,
    [],
    [],
    ChatSlice
> = (set) => ({
    chatPrefillMessage: "",
    setChatPrefillMessage: (message: string) =>
        set({ chatPrefillMessage: message }),
    clearChatPrefillMessage: () =>
        set({ chatPrefillMessage: "" }),
});
